import React, { useState, useEffect, useRef, useLayoutEffect, forwardRef } from "react";
import { createPortal } from 'react-dom';
import setRef from './../../setRef';
import styles from './Popover.module.less';
export const Popover = forwardRef(function ({ children, position, hideOnClick = true }, ref) {
    const [shown, show] = useState(!!position);
    useEffect(() => show(!!position), [position]);
    useEffect(() => {
        const esc = (e) => {
            if (e.key == 'Escape' && shown) {
                e.stopPropagation();
                show(false);
            }
        };
        document.addEventListener('keydown', esc, { passive: true });
        return () => document.removeEventListener('keydown', esc);
    }, [shown]);
    return (React.createElement(React.Fragment, null, shown && position &&
        createPortal(React.createElement("div", { className: styles.overlay, onMouseDown: e => { e.preventDefault(); show(false); }, onContextMenu: e => { e.preventDefault(); show(false); } },
            React.createElement(PopoverContent, { ref: ref, x: position.x, y: position.y, onClick: () => show(!hideOnClick) }, children)), document.body)));
});
export const PopoverContent = forwardRef(function ({ children, x, y, onClick }, ref) {
    const rootEl = useRef(null);
    const [point, setPoint] = useState({ left: x, top: y });
    const [shown, show] = useState(false);
    useLayoutEffect(() => {
        show(false);
        const tm = setTimeout(() => {
            if (rootEl.current) {
                const { width, height } = rootEl.current.getBoundingClientRect();
                const { clientWidth, clientHeight } = document.documentElement;
                const left = (x + width) > clientWidth ? x - width : x;
                const top = y + Math.min(0, clientHeight - y - height - 10);
                setPoint({ left, top });
                show(true);
            }
        }, 200);
        return () => clearTimeout(tm);
    }, [x, y]);
    return (React.createElement("div", { ref: setRef(rootEl, ref), className: styles.content, style: {
            left: `${point.left}px`,
            top: `${point.top}px`,
            visibility: shown ? 'visible' : 'hidden',
        }, onMouseDown: e => { e.preventDefault(); e.stopPropagation(); onClick(); } }, children));
});
